import script from "./WordProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./WordProgress.vue?vue&type=script&setup=true&lang=js"

import "./WordProgress.vue?vue&type=style&index=0&id=df6e57ea&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df6e57ea"]])

export default __exports__